import { createUseStyles } from "react-jss";
import { colors } from "../../styles/colors";

type StyleProps = {
  marginBottom?: string | number;
  rows?: string | number;
  error?: string;
};

const useStyles = createUseStyles((_) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    marginBottom: (props: StyleProps) => props.marginBottom || "16px",
  },
  containerLabel: {
    marginBottom: "8px",
    display: "flex",
    alignItems: "center",
  },
  formControl: {
    width: "100%",
    
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      backgroundColor: colors.surface,
      border: `1px solid ${colors.borderLight}`,
      minHeight: (props: StyleProps) => props.rows ? `${Number(props.rows) * 24 + 32}px` : "auto",
      
      "& fieldset": {
        borderColor: (props: StyleProps) => props.error ? colors.error : colors.borderLight,
        borderWidth: "1px",
      },
      
      "&:hover fieldset": {
        borderColor: (props: StyleProps) => props.error ? colors.error : colors.borderDark,
      },
      
      "&.Mui-focused fieldset": {
        borderColor: (props: StyleProps) => props.error ? colors.error : colors.primary,
        borderWidth: "2px",
      },
      
      "&.Mui-error fieldset": {
        borderColor: colors.error,
      },
      
      "& .MuiOutlinedInput-input": {
        padding: "12px 16px",
        fontSize: "14px",
        fontFamily: "inherit",
        lineHeight: "1.5",
        color: colors.textPrimary,
        
        "&::placeholder": {
          color: colors.textSecondary,
          opacity: 1,
        },
        
        "&.Mui-disabled": {
          backgroundColor: colors.backgroundLight,
          color: colors.textDisabled,
        },
      },
      
      "&.Mui-disabled": {
        backgroundColor: colors.backgroundLight,
        
        "& fieldset": {
          borderColor: colors.textDisabled,
        },
      },
    },
  },
  errorContainer: {
    marginTop: "4px",
    minHeight: "20px",
  },
}));

export default useStyles;